import React from 'react';
import { useState,useEffect } from 'react';
import "./Search.css";
import SearchBoxAPI from '../../APICalls/SearchBoxAPI';


const Search = () => {
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [desc, setDesc] = useState("");
  const [selectedResult, setSelectedResult] = useState(null);
  const [isSearching, setIsSearching] = useState(true);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchRequest, setSearchRequest] = useState(0);

  const fetchData = async () => {	
    setIsSearching(true);

    try {
      const fetchedData = await SearchBoxAPI(desc);
      setData(Array.isArray(fetchedData) ? fetchedData : []);
    } finally {
      setIsSearching(false);
    }
  };
    useEffect(() => {
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[desc, searchRequest]);

  const handleChange = (e) => {
    setSearchInput(e.target.value);
  }

  const handleSearch = () => {
    const mod = searchInput.trim().replace(/\s+/g, "%");
    setHasSearched(true);
    setData([]);
    setDesc(mod);
    setSearchRequest((request) => request + 1);
  
  }

  const closeResult = () => setSelectedResult(null);


    return (
      <main className='containerSearchPage' >
        <div className='searchIntro'>
          <p className='searchEyebrow'>THE NASA ARCHIVE</p>
          <h1>Search the universe</h1>
          <p>Find images, missions, and moments from NASA's public archive.</p>
        </div>
        <div className='search-box'  >
          <input
            type="text"
            placeholder="Search here"
            onChange={handleChange}
            value={searchInput} />
          <button type='submit'  onClick={handleSearch}   className="searchBut"  >Submit</button>

        </div>
        {isSearching && (
          <div className='searchStatus' role='status' aria-live='polite'>
            <span className='searchSpinner' aria-hidden='true'></span>
            <p>Searching the NASA archive...</p>
          </div>
        )}
        {!isSearching && hasSearched && data.length === 0 && (
          <div className='searchStatus emptySearch' role='status'>
            <p>Nothing came up.</p>
            <span>Try again with new, specific keywords.</span>
          </div>
        )}
        {!isSearching && data.length > 0 && (
          <div className='gallery'>
            {data.map((ele) => (
                <article
                    key={ele.data[0].nasa_id}
                    className='gallery-item'
                    role='button'
                    tabIndex='0'
                    onClick={() => setSelectedResult(ele)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setSelectedResult(ele);
                      }
                    }}
                >
                    <img src={ele.links[0].href} className='singlePhotoSRC' alt="Issue in loading pHotos" />
                    <div className='galleryCaption'>
                      <p>{ele.data[0].date_created.slice(0, 10)}</p>
                      <h2>{ele.data[0].title}</h2>
                      <button className='searchReadMore' type='button' onClick={() => setSelectedResult(ele)}>
                        Read more
                      </button>
                    </div>
                </article>
            ))}
          </div>
        )}
        {selectedResult && (
          <div className='searchOverlay' role='presentation' onClick={closeResult}>
            <section
              className='searchDetail'
              role='dialog'
              aria-modal='true'
              aria-labelledby='search-detail-title'
              onClick={(event) => event.stopPropagation()}
            >
              <button className='closeSearch' type='button' aria-label='Close search result' onClick={closeResult}>
                <span aria-hidden='true'>&#215;</span>
              </button>
              <div className='searchDetailImage'>
                <img src={selectedResult.links[0].href} alt={selectedResult.data[0].title} />
              </div>
              <div className='searchDetailBody'>
                <p>{selectedResult.data[0].date_created.slice(0, 10)}</p>
                <h2 id='search-detail-title'>{selectedResult.data[0].title}</h2>
                <p className='fullDescription'>{selectedResult.data[0].description || 'No description is available for this archive item.'}</p>
              </div>
            </section>
          </div>
        )}
      </main>
    )
  }

export default Search